import manageJss from "@microsoft/fast-jss-manager-react";
import { Grid as BaseGrid, GridAlignment, GridTag, } from "./grid";
const Grid = manageJss()(BaseGrid);
export { Grid, GridTag, GridAlignment, };
